<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Job History'"
      [canGoBack]="!cantGoBack"
      [customBack]="'more'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (windowService.isDesktopRes) {
      <tidy-desktop-header [isLoading]="!loaded">
        <div class="wrappable-container">
          <tidy-image
            [src]="'assets/svg/arrow-back-black.svg'"
            (action)="goBack()"
            class="desktop-back-icon" />
          <tidy-text [title]="'Job History'" />
          <tidy-header-datepicker
            (customDateOption)="selectCustomDateRange($event)"
            (stringDateOption)="selectStringDateRange($event)"
            [(dateRangeForm)]="dateRangeForm"
            [selectOptions]="selectOptions"
            [header]="true"
            [icon]="'assets/svg/calendar.svg'" />
          <tidy-header-select
            [items]="addressFilter"
            [form]="desktopPropertyForm.get('property')"
            (optionChange)="changeAddress($event)"
            [icon]="'assets/svg/home.svg'" />
        </div>
      </tidy-desktop-header>
    }

    @if (loaded) {
      <div [class.past-jobs-scrollable-content]="windowService.isDesktopRes">
        @if (!windowService.isDesktopRes) {
          <tidy-row class="extra-bottom-padding" [align]="'center'">
            <tidy-text [body]="'Only past jobs that were billed will show in your job history. For billing history,'" />
            <span>&nbsp;</span>
            <tidy-text
              [body]="'tap here'"
              (action)="goToBillingHistory()"
              class="link" />
            <tidy-text [body]="'.'" />
          </tidy-row>
        }
        @if (windowService.isDesktopRes) {
          <tidy-row class="extra-bottom-padding">
            <tidy-text [body]="'Only past jobs that were billed will show in your job history. For billing history,'" />
            <span>&nbsp;</span>
            <tidy-text
              [body]="'tap here'"
              (action)="goToBillingHistory()"
              class="link" />
            <tidy-text [body]="'.'" />
          </tidy-row>
        }
        @if (!windowService.isDesktopRes) {
          <form [formGroup]="form" novalidate action="#" class="extra-bottom-padding">
            <div style="margin-bottom: 1rem">
              <tidy-select
                class="select-custom-input"
                [icon]="'assets/svg/home.svg'"
                [label]="'Property'"
                [items]="addressFilter"
                [form]="form.get('property')"
                formControlName="property"
                (optionChange)="changeAddress($event)"
                [multiple]="true" />
            </div>
            <div class="daterange-custom-container">
              <tidy-daterange
                class="daterange-custom-input"
                [icon]="'assets/svg/calendar.svg'"
                [label]="'Date Range'"
                (customDateOption)="selectCustomDateRange($event)"
                (stringDateOption)="selectStringDateRange($event)"
                [(dateRangeForm)]="dateRangeForm"
                [selectOptions]="selectOptions"
                [rangeOption]="true"
                [appearance]="'outline'" />
            </div>
          </form>
        }
        @if (shownHistory?.length == 0) {
          <tidy-row [align]="'center'">
            <tidy-alert>
              <tidy-text [body]="'You have no past jobs'" />
            </tidy-alert>
          </tidy-row>
        }
        @for (cleaning of shownHistory; track cleaning; let last = $last) {
          <tidy-card>
            <tidy-card-button (action)="goToCleaningDetail(cleaning)">
              <tidy-row class="extra-bottom-padding">
                <tidy-text [header]="cleaning?.service | titlecase" />
              </tidy-row>
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/book.svg'"
                  class="body-size" />
                <tidy-text [body]="cleaning?.start_datetime_local | parseDateTime: 'dddd MMM d'" />
                <span>&nbsp;</span>
                <tidy-text [body]="'at'" />
                <span>&nbsp;</span>
                <tidy-text [body]="cleaning?.start_datetime_local | parseDateTime: 'h:mma'" />
              </tidy-row>
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/home.svg'"
                  class="body-size" />
                <tidy-text
                  [body]="cleaning?.display_address"
                  [translate]="false" />
              </tidy-row>
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="cleaning?.status?.icon"
                  class="body-size theme-icon-filter" />
                <tidy-text [body]="'Status:'" />
                <span>&nbsp;</span>
                <tidy-text [body]="cleaning?.status?.name | titlecase" />
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
        }

        @if (shownHistory?.length > 0) {
          <mat-paginator
            style="background: none"
            [length]="totalRecords"
            [pageSize]="pageSize"
            [pageSizeOptions]="[5, 10, 25, 100]"
            (page)="selectPage($event)" />
        }
      </div>
    }
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="windowService.isDesktopRes"
  [templateContent]="content" />